<template>
	<div class="content">
		<arrorImg bg="white"></arrorImg>
		<navBar title="书币" color="#ffffff"></navBar>
				<div class="content-box">
					<span class="tips">优先扣除即将过期的赠币；未使用的赠币，在到期日24点失效</span>
					<div class="curreny_top">
						<span>书币总额</span>
						<div>
							<img src="../../../static/money.png" alt="">
							<span>{{currency}}</span>
						</div>
					</div>
					<div class="forever_currency">
						<span>永久书币</span>
						<div>
							<div>
								<img src="../../../static/money.png" alt="">
								<span>{{permanentCurrency}} 永久</span>
							</div>
							<span @click="goCharge">充值</span>
						</div>
					</div>
					<div >
						<div class="give_currency">
							<span>赠送书币</span>
							<div @click="routeCurrency"><span>过期记录</span>
							<img src="../../../static/gray-arrow.png" alt=""></div>
						</div>
						<div class="give_list" v-if="isEmpaty">
							 <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
                               <li class="give_list_item" :key="index" v-for="(item,index) in List">
								   <div>
									   <img src="../../../static/money.png" alt="">
									   <span>{{item.presentCurrency}} 赠币</span>
								   </div>
								   <div>
									   <span>有效期至 {{item.termOfValidity}}</span>
									   <span v-if="item.daysRemaining>=1">剩{{item.daysRemaining}}天</span>
									   <span v-else>今日到期</span>
								   </div>
							   </li>	
							 </ul>
								<span class="no-more">{{ !isLoading ?'加载中':loadText }}</span>
						</div>
						<div class="no-log" v-else>
							<img src="../../../static/no-log.png"  alt="">
							<span>暂无记录~</span>
						</div>
					</div>
				</div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	import arrorImg from "../../components/arrow-img.vue";
	import navBar from '../components/navbar.vue'
	export default {
		components: {
			arrorImg,
			navBar
		},
		data(){
			return{
				loading:false,
				isEmpaty:true,
				isReload:false,
				pageType:'',
				currency:0,
				permanentCurrency:0,
				List:[],
				pageNo:1,
				CountPage:0,
				pageSize:10,
				messageType: '',//消息类型
				clickMessId: 0,//消息ID
				channelRecordId:0,//渠道号
				promotionCode:'',//推广链接
				isEntranceData:'',
					loadText:"没有更多了~",
					isLoading:false
			}
		},
		mounted() {
			this.pageType=this.$route.query.pageType;
			if (this.$route.query.isEntranceData) {
				this.isEntranceData = this.$route.query.isEntranceData;
			}
			if(this.$route.query.promotionCode){
				this.promotionCode = this.$route.query.promotionCode;
			}
			if (this.$route.query.messageType) {
				this.clickMessId = this.$route.query.clickMessId;
				this.messageType = this.$route.query.messageType;
			}
			if (this.$route.query.channelRecordId) {
				this.channelRecordId = this.$route.query.channelRecordId;
			}
			var openid =  this.$base.getStorage('openid');
			var isWxAuthorized =  this.$base.getStorage('isWxAuthorized');
			 var city = this.$base.getStorage("city");
			if (!openid) { //静默登录手动登录
				// this.wechatLogin()
			} else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
				 this.$base.setStorage('isSNS', true)
				this.$store.state.user.isSNS = true;
				this.$commonApi.snsapiUserinfo();
				this.insertPageAccessData();
				this.presentCurrencyList();
				this.getUserTotalCurrency();
			} else {
				this.presentCurrencyList();
				this.insertPageAccessData();
				this.getUserTotalCurrency();
			}
			this.$commonApi.share();
		},
		methods:{
				 loadMore() {
		this.loading = true;
	if (this.pageNo < this.CountPage) {
          this.pageNo += 1;
          this.presentCurrencyList();
        } else {
   this.loadText = "没有更多了";
        	this.loading = false;
        }
		},
			insertPageAccessData() {
				var prevPage = '';
				if (this.pageType === "bookCity") {
        prevPage = "书城";
      } else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      } else if (this.pageType === "bookMine") {
        prevPage = "我的";
      }
				var params = {
					pageName: '书币',
					pageRemark: '上级页面：' + prevPage,
					isEntranceData: this.isEntranceData
				}
				this.$api.insertPageAccessData(params).then(res => {
			
				})
			},
			goCharge(){
				this.$router.push({
					path:'/pages/bookCharge/index',
					query:{
						pageType:'bookCurrency'
					}
				})
			},
			wechatLogin() {
				var code = this.$base.GetUrlParam('code');
				if (!code) {
					console.log(window.location.href)
					// snsapi_base//静默   snsapi_userinfo手动
					let uri = encodeURIComponent(window.location.href);
					window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.$store.state.user
						.appid +
						"&redirect_uri=" + uri +
						"&response_type=code&scope=snsapi_base&state=state&wechat_redirect&connect_redirect=1#wechat_redirect"
				} else {
					this.userRegister(code); //静默注册
				}
			},
			userRegister(code) {
				var params = {
					code: code
				}
				this.$api.userRegister(params).then(res => {
					if (res.status == 1) {
						 this.$base.setStorage('openid', res.data.openid)
						if (res.data.isNewUser == 1) { //如果是新用户进行手动授权一次
							this.$router.push({
								path:'/pages/bookFrency/index',
								query:{
									pageType:'bookActivity'
								}
							})

						}
						var id =  this.$base.getStorage('uid');
						this.getUserTotalCurrency();
						this.presentCurrencyList();
						if (!id) {
							this.$commonApi.getUserInfo(res.data.openid)
						}
					}
				})
			},
			getUserTotalCurrency(){
				this.$api.getUserTotalCurrency().then(res=>{
					console.log(res)
					if(res.status==1){
						this.permanentCurrency=res.data.permanentCurrency;
						this.currency = res.data.totalCurrency;
					}
				})
				},
			presentCurrencyList(){
				var params={
					isBeOverdue:0,
					pageNo:this.pageNo,
					pageSize:this.pageSize
				}
				this.isLoading=false;
				this.$api.presentCurrencyList(params).then(res=>{
						if(res.status==1){
							this.CountPage = res.pages;
							if(this.pageNo<=this.CountPage){
								if (this.pageNo == 1) {
									this.List=res.data;
									if (this.CountPage > 1) {
										this.loadingText = '加载中...'
									} else {
										this.loadingText = '没有更多了'
									}
								} else {
									this.List = this.List.concat(res.data)
								}
							}else{
								this.isEmpaty=false;
							}
							this.isLoading=true;
						}
					})
				},
			routeCurrency(){
					this.$router.push({
								path:'/pages/currencyOverdue/index',
								query:{
									pageType:'bookCurrency'
								}
							})
			}
			
		}
	}
</script>

<style scoped>
	.content{
		/* height:calc(48px + env(safe-area-inset-bottom)); */
		  padding-bottom: constant(safe-area-inset-bottom);
		/* 兼容 iOS < 11.2 */
		padding-bottom:env(safe-area-inset-bottom);
		/* 兼容 iOS >= 11.2 */
		/* box-sizing: content-box; */
	}
	.no-log {
		text-align: center;
		margin-top:20px;
		/* position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%); */
	}
	
	.no-log img {
		width: 128px;
		height: 128px;
		display: block;
		margin: 0 auto;
	
	}
	
	.no-log span {
		display: block;
		font-size: 14px;
		color: #666666;
		margin-top: 20px;
	}
	.content-box{
		margin-top:calc(44px + env(safe-area-inset-top));
		}
		.tips{
			font-size: 12px;
			line-height: 17px;
			color: #F09B28;
			display: block;
			padding:4px;
			background-color: #FDF5E9;
			text-align: center;
		}
		.curreny_top{
			text-align: center;
			padding-top: 20px;
			padding-bottom: 25px;
			border-bottom: 8px solid #F3F3F3;
		}
		.curreny_top>span{
			font-size: 16px;
			color: #333333;
			font-weight: bold;
			line-height: 22px;
		}
		.curreny_top>div{
			display: flex;
			margin-top: 12px;
			justify-content: center;
		}
		.curreny_top>div>span{
			font-size: 24px;
			line-height: 24px;
		}
		.curreny_top img{
			width: 24px;
			height: 24px;
			margin-right: 8px;
		}
		.forever_currency{
			padding:20px 16px;
				border-bottom:1px solid #F3F3F3;
		}
		.forever_currency>span{
			font-size: 16px;
			color: #333333;
			text-align: left;
			font-weight: bold;
			display: block;
		}
		.forever_currency>div{
			display: flex;
			justify-content: space-between;
			padding-top:10px;
			/* height: 20px;
			line-height: 20px; */
		}
		.forever_currency>div img{
			width:16px;
			height:16px;
			margin-right:8px;
			margin-top:2px;
		}
		.forever_currency>div>div{
			    display: flex;
			    margin-top: 4px;
		}
		.forever_currency>div>div>span{
			font-size: 14px;
			color: #333333;
			line-height: 20px;
			
		}
		.forever_currency>div>span{
			color: #ffffff;
			width: 64px;
			height:24px;
			text-align: center;
			line-height: 24px;
			background-color: #DE3B34;
			border-radius: 20px;
			font-size: 12px;
		}
		.give_currency{
			display: flex;
			padding-top:20px;
			justify-content: space-between;
			padding-left:16px;
			padding-right:16px;
		}
		.give_currency>span{
			font-size: 16px;
			color: #333333;
			text-align: left;
			font-weight: bold;
			display: block;
		}
		.give_currency>div{
			display:flex;
		}
		.give_currency>div>span{
			font-size: 14px;
			color: #AAAAAA;
			margin-right:8px;
		}
		.give_currency>div>img{
			width: 6px;
			height:12px;
			margin-top:4px;
		}
		.give_list_item{
			display: flex;
			justify-content: space-between;
			border-bottom:1px solid #f3f3f3;
			padding:20px 16px;
			}
			.give_list_item>div>img{
				width: 16px;
				height: 16px;
				margin-right:8px;
				margin-top: 2px;
			}
			.give_list_item>div:nth-child(1){
				display: flex;
			}
			.give_list_item>div:nth-child(1)>span{
				font-size: 14px;
				line-height: 20px;
				color: #333333;
			}
			.give_list_item>div:nth-of-type(2)>span{
				font-size: 12px;
				color: #AAAAAA;
				line-height: 17px;
			}
			.give_list_item>div:nth-of-type(2)>span:nth-of-type(2){
				color: #F09B28;
				background-color: #FDF5E9;
				padding:1px 7px;
				margin-left:8px;
				border-radius: 2px;
			}
			.no-more{
				display: block;
				text-align: center;
				font-size: 14px;
				color: #AAAAAA;
				margin-top: 10px;
				padding: 20px 0px;
			}

</style>



// WEBPACK FOOTER //
// src/view/bookCurrency/index.vue